import styled from 'styled-components';

export const Bar = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 99;
    display: flex;
    align-items: center;
    gap: 5px; // Dot 있이 갈꺼면 12px
    padding: 6px 12px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    color: #fff;
    font-size: 12px;
    line-height: 1;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const Item = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const Dot = styled.span<{color: string}>`
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: ${({color}) => color};
`;

export const Name = styled.span<{color: string}>`
    font-weight: 500;
    opacity: 0.9;
    color: ${({color}) => color};
`;

export const Count = styled.span<{color: string}>`
    font-weight: 600;
    opacity: 0.85;
    color: ${({color}) => color};
`;
